module.exports = __webpack_public_path__ + "static/media/menu-goals.06805b1c.svg";